import axios from './axios';

export const getSemuaKonfigurasi = () => {
  return axios.get(`/admin/konfigurasi`);
};

export const postUpdateKonfigurasi = (id: string, data: any) => {
  return axios.post(`/admin/konfigurasi/${id}`, data);
};
